import type { SdkWorkspaceField } from '@Pages/pageRuntime/sdk/types';
import {
  createWorkspaceValuesStore,
  type WorkspaceValuesStore
} from '@Pages/pageRuntime/sdk/workspaceValuesStore';
import { createContext, useContext } from 'react';

export type WorkspaceFieldsRuntime = {
  values: WorkspaceValuesStore;
  fields: Record<string, SdkWorkspaceField>;
  /**
   * Whether the identity holds `update_workspace_fields` or `manage_workspace_fields`. Read from the SDK identity,
   * not the Inertia `identity` prop, so a preview-as-user session gates as the previewed
   * identity the same way `Sdk.permissions` does for page code.
   */
  canUpdate: boolean;
};

/**
 * Without a provider (unit tests, components rendered outside a page) there are no
 * fields, an empty values store, and no permission to save.
 */
export const WorkspaceFieldsContext = createContext<WorkspaceFieldsRuntime>({
  values: createWorkspaceValuesStore({}),
  fields: {},
  canUpdate: false
});

export function useWorkspaceFieldsRuntime(): WorkspaceFieldsRuntime {
  return useContext(WorkspaceFieldsContext);
}
